import { render, staticRenderFns } from "./flightSearch.vue?vue&type=template&id=6967f2c3&scoped=true"
import script from "./flightSearch.vue?vue&type=script&lang=js"
export * from "./flightSearch.vue?vue&type=script&lang=js"
import style0 from "./flightSearch.vue?vue&type=style&index=0&id=6967f2c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6967f2c3",
  null
  
)

export default component.exports